import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="overflow-hidden bg-[#030712] pt-16">
    <div className="mx-auto flex max-w-7xl flex-col gap-6 px-5 sm:flex-row sm:items-center sm:justify-between sm:px-8">
      <Logo />
      <p className="text-sm text-slate-400" data-testid="footer-copyright">© {new Date().getFullYear()} Core Websites. All rights reserved.</p>
    </div>
    <p aria-hidden className="mt-10 select-none whitespace-nowrap text-center font-display text-[17vw] font-semibold leading-[0.8] tracking-[-0.05em] text-transparent [-webkit-text-stroke:1px_rgba(59,130,246,0.35)]">
      CORE WEBSITES
    </p>
  </footer>
);
